import React from 'react'
import { withRouter, Route } from 'react-router-dom'

import SupplierList from '../pages/supplierRecantion/supplierList'
import ListDetail from '../pages/supplierRecantion/listDetails'
import SendList from '../pages/supplierRecantion/sendList'
import AddSend from '../pages/supplierRecantion/addSend'
import SendDetails from '../pages/supplierRecantion/sendDetails'
import SummaryPrint from '../pages/supplierRecantion/summaryPrint'
import DetailsPrint from '../pages/supplierRecantion/detailsPrint'

// 订单管理
import OrderList from '../pages/orderAdmin/orderList'
import BuyOrderDetails from '../pages/orderAdmin/buyOrderDetails'
import PrintOrder from '../pages/orderAdmin/printOrder'
// 发货管理
import DeliverList from '../pages/deliverGoods/deliverList'
import DeliverListNew from '../pages/deliverGoodsNew/deliverList'
import DifferReport from '../pages/differReport/index'
// 退货管理
import ReturnOrder from '../pages/returnGoods/returnOrder'
import OrderDetails from '../pages/returnGoods/orderDetails'
// import Complaint from '../pages/returnGoods/complaint'

// 商品管理--列表---（基础添加，完整添加）---详情
import CommodityManagementList from '../pages/commoditymanagement/commoditymanagementlist/commodity-management-list'
import CommodityManagementAdd from '../pages/commoditymanagement/commoditymanagementadd/commodity-management-add'
import MedicalEquipmentnOnhaitao from '../pages/commoditymanagement/addcompleteinformation/medicalequipmentnonhaitao/medical-equipmentn-onhaitao'
import MedicalEquipmentnHaitao from '../pages/commoditymanagement/addcompleteinformation/medicalequipmentnhaitao/medical-equipmentn-haitao'
import NonMedicalDevices from '../pages/commoditymanagement/addcompleteinformation/nonmedicaldevices/no-nmedical-devices'
// -------商品资质-----//
import CommodityQualification from '../pages/commoditymanagement/commodityqualification/commodity-qualification'
import CorrespondingManufacturerGoods from '../pages/commoditymanagement/commodityqualification/corresponding-manufacturer-goods'
import ManufacturerDetail from '../pages/commoditymanagement/commodityqualification/manufacturerdetail'

// 新品修改
import AddInfomation from '../pages/commoditymanagement/addinfomation/add-infomation'
// import AddInfomation from '../pages/commoditymanagement/addinfomation/index'

import DetailsInfomation from '../pages/commoditymanagement/newproductdetails/details-infomation'

import BasicCommodityDetails from '../pages/commoditymanagement/commoditydetails/basiccommoditydetails/basic-commodity-details'
import MedicalEquipmentnHaitaoDetails from '../pages/commoditymanagement/commoditydetails/completeinformationdetails/medicalequipmentnhaitaodetails/medical-equipmentn-haitao-details'
import MedicalEquipmentnOnhaitaoDetails from '../pages/commoditymanagement/commoditydetails/completeinformationdetails/medicalequipmentnonhaitaodetails/medical-equipmentn-onhaitao-details'
import NonMedicalDevicesDetails from '../pages/commoditymanagement/commoditydetails/completeinformationdetails/nonmedicaldevicesdetails/no-nmedical-devices-details'

// 权限管理
import UserManagement from '../pages/authorityManagement/userManagement'
import RoleManagement from '../pages/roleManagement/roleManagement'
import PermissionSettings from '../pages/roleManagement/permissionSettings'
import UsersSetting from '../pages/roleManagement/usersSetting'
import setRole from '../pages/authorityManagement/setRole'
import EmptyPage from '../pages/emptyPage/emptyPage'

// 品牌资质
import BrandQualificationList from '../pages/brandqualification/brand-qualification-list'
import BrandQualificationEdit from '../pages/brandqualification/brand-qualification-edit'

// 质量管理-投诉信息查询
import ComplaintInformationInquiry from '../pages/complaintinformationinquiry/complaint-information-inquiry'
import NophysicalComplaintPrinting from '../pages/complaintinformationinquiry/nophysical-complaint-printing'

// 质量管理-投诉信息查询（新版，对接新接口）
import NewComplaintInformationInquiry from '../pages/newcomplaintinformationinquiry/complaint-information-inquiry'
import NewNophysicalComplaintPrinting from '../pages/newcomplaintinformationinquiry/nophysical-complaint-printing'
import ReportPrint from '../pages/differReport/reportPrint'
import ReportDetails from '../pages/differReport/reportDetails'

// --------------------收据报表---------------
// 销售报表--》销售总览-销售统计列表
import SalesOverview from '../pages/salesreport/salesoverview/sales-overview'
import SalesStatisticSreport from '../pages/salesreport/salesstatisticsreport/salesstatisticsreport'

// 供应商入驻 ---<供应商注册>
import SupplierRegistration from '../pages/suppliersettlement/supplierregistration/supplierregistration'
import FindPassword from '../pages/suppliersettlement/findpassword/findpassword'



import NewSupplierInformationEntry from '../pages/newsuppliersettlement/supplierinformationentry/supplier-information-entry'
import NewComplianceCertification from '../pages/newsuppliersettlement/compliancecertification/index'

import UdiBindUdi from '../pages/udi/bindUdi'
import ProductCatalogs from '../pages/commoditymanagement/productCatalogs'
import ProductCatalogsDetail from '../pages/commoditymanagement/productCatalogDetail'
import SupplierGoodList from '../pages/supplierGood/list'
import SupplierGoodDetail from '../pages/supplierGood/detail'
import PrintScmOrder from '../pages/orderAdmin/printScmOrder'
import BillMatchList from '../pages/billVerification/match/list/list'
import BillMatchDetail from '../pages/billVerification/match/detail/detail'
import artificialCreateBill from '../pages/billVerification/createBills/artificialCreate/ManualUpload'
import InvoiceVerificationList from '../pages/billVerification/invoiceVerification/list'
import StatementPaymentProgress from '../pages/statementPaymentProgress'
import SafeSetting from '../pages/login/setting'
import home from '../pages/home/index'
import MenuUpdate from '../pages/menuUpdate/index'
class AppRoute extends React.Component {
  render() {
    return (
      <div>
        {/* 安全设置 */}
        <Route path="/main/login/setting" component={SafeSetting} />
        <Route path="/main/emptyPage/emptyPage" component={EmptyPage} />
        {/* 供应商对账 */}
        {/* 订单管理 */}
        <Route path="/main/orderAdmin/orderList" component={OrderList} />
        <Route path="/main/orderAdmin/buyOrderDetails" component={BuyOrderDetails} />
        <Route path="/main/orderAdmin/printOrder" component={PrintOrder} />
        {/* 发货管理 */}
        <Route path="/main/deliverGoods/deliverList" component={DeliverList} />
        {/* 发货管理（新） */}
        <Route path="/main/deliverGoodsNew/deliverList" component={DeliverListNew} />
        {/* 收货单 */}
        <Route path="/main/differReport/index" component={DifferReport} />
        <Route path="/main/differReport/reportPrint" component={ReportPrint} />
        <Route path="/main/differReport/reportDetails" component={ReportDetails} />
        {/* 采购单打印 */}
        <Route path="/main/differReport/scmorderprint" component={PrintScmOrder} />
        {/* 退货管理 */}
        <Route path="/main/returnGoods/returnOrder" component={ReturnOrder} />
        <Route path="/main/returnGoods/orderDetails" component={OrderDetails} />
        {/* <Route path="/main/returnGoods/complaint" component={Complaint} /> */}
        {/* 供应商对账 */}
        <Route path="/main/supplierRecantion/supplierList" component={SupplierList} />
        <Route path="/main/supplierRecantion/listDetails" component={ListDetail} />
        <Route path="/main/supplierRecantion/sendList" component={SendList} />
        <Route path="/main/supplierRecantion/addSend" component={AddSend} />
        <Route path="/main/supplierRecantion/sendDetails" component={SendDetails} />
        <Route path="/main/supplierRecantion/summaryPrint" component={SummaryPrint} />
        <Route path="/main/supplierRecantion/detailsPrint" component={DetailsPrint} />

        {/* 商品管理--列表---添加---详情 */}
        <Route path="/main/commoditymanagement/commoditymanagementlist/commodity-management-list" component={CommodityManagementList} />
        <Route path="/main/commoditymanagement/commoditymanagementadd/commodity-management-add" component={CommodityManagementAdd} />
        <Route path="/main/commoditymanagement/addcompleteinformation/medicalequipmentnonhaitao/medical-equipmentn-onhaitao" component={MedicalEquipmentnOnhaitao} />
        <Route path="/main/commoditymanagement/addcompleteinformation/medicalequipmentnhaitao/medical-equipmentn-haitao" component={MedicalEquipmentnHaitao} />
        <Route path="/main/commoditymanagement/addcompleteinformation/nonmedicaldevices/no-nmedical-devices" component={NonMedicalDevices} />
        <Route path="/main/commoditymanagement/addinfomation/add-infomation" component={AddInfomation} />
        <Route path="/main/commoditymanagement/newproductdetails/details-infomation" component={DetailsInfomation} />

        {/** 商品资质 */}
        <Route path="/main/commoditymanagement/commodityqualification/commodity-qualification" component={CommodityQualification} />
        <Route path="/main/commoditymanagement/commodityqualification/manufacturerdetail" component={ManufacturerDetail} />
        <Route path="/main/commoditymanagement/commodityqualification/corresponding-manufacturer-goods" component={CorrespondingManufacturerGoods} />

        <Route path="/main/commoditymanagement/commoditydetails/basiccommoditydetails/basic-commodity-details" component={BasicCommodityDetails} />
        <Route path="/main/commoditymanagement/commoditydetails/completeinformationdetails/medicalequipmentnhaitaodetails/medical-equipmentn-haitao-details" component={MedicalEquipmentnHaitaoDetails} />
        <Route path="/main/commoditymanagement/commoditydetails/completeinformationdetails/medicalequipmentnonhaitaodetails/medical-equipmentn-onhaitao-details" component={MedicalEquipmentnOnhaitaoDetails} />
        <Route path="/main/commoditymanagement/commoditydetails/completeinformationdetails/nonmedicaldevicesdetails/no-nmedical-devices-details" component={NonMedicalDevicesDetails} />

        {/* 角色管理 */}
        <Route path="/main/authorityManagement/userManagement" component={UserManagement} name='用户管理'/>
        <Route path="/main/authorityManagement/setRole" component={setRole} name='用户管理-设置角色'/>
        <Route path="/main/roleManagement/roleManagement" component={RoleManagement} name='角色管理'/>
        <Route path="/main/roleManagement/permissionSettings" component={PermissionSettings} name='角色管理-设置权限'/>
        <Route path="/main/roleManagement/usersSetting" component={UsersSetting} name='角色管理-设置用户'/>

        {/* 品牌资质 */}
        <Route path="/main/brandqualification/brand-qualification-list" component={BrandQualificationList} />
        <Route path="/main/brandqualification/brand-qualification-edit" component={BrandQualificationEdit} />

        {/* 质量管理-投诉信息查询 */}
        <Route path="/main/complaintinformationinquiry/complaint-information-inquiry" component={ComplaintInformationInquiry}></Route>
        <Route path="/main/complaintinformationinquiry/nophysical-complaint-printing" component={NophysicalComplaintPrinting}></Route>

        {/* 质量管理-投诉信息查询（新版，对接新接口） */}
        <Route path="/main/newcomplaintinformationinquiry/complaint-information-inquiry" component={NewComplaintInformationInquiry}></Route>
        <Route path="/main/newcomplaintinformationinquiry/nophysical-complaint-printing" component={NewNophysicalComplaintPrinting}></Route>

        {/* 数据报表-销售总览--销售统计列表 */}
        <Route path="/main/salesreport/salesoverview/sales-overview" component={SalesOverview}></Route>
        <Route path="/main/salesreport/salesstatisticsreport/salesstatisticsreport" component={SalesStatisticSreport}></Route>

        {/** 供应商入驻 ---注册---审核---详情 */}
        <Route path="/main/suppliersettlement/supplierregistration/supplierregistration" component={SupplierRegistration}></Route>

        <Route path="/main/suppliersettlement/supplierinformationentry/new-supplier-information-entry" component={NewSupplierInformationEntry}></Route>
        <Route path="/main/suppliersettlement/compliancecertification/" component={NewComplianceCertification}></Route>

        {/* 供应商忘记密码 */}
        <Route path="/main/suppliersettlement/findpassword/findpassword" component={FindPassword}></Route>
        <Route path="/main/udi/bindUdi" component={UdiBindUdi}></Route>
        <Route path="/main/commoditymanagement/productCatalogs" component={ProductCatalogs}></Route>
        <Route path="/main/commoditymanagement/productCatalogsDetail" component={ProductCatalogsDetail}></Route>
        <Route path="/main/supplierGood/list" component={SupplierGoodList}></Route>
        <Route path="/main/supplierGood/detail" component={SupplierGoodDetail}></Route>
        <Route path="/main/bill/match/list" component={BillMatchList}></Route>
        <Route path="/main/bill/match/detail" component={BillMatchDetail}></Route>
        <Route path="/main/bill/create/artificial" component={artificialCreateBill}></Route>

        {/* 供应商SCS发票校验（新） */}
        <Route path="/main/bill/invoiceVerification/list" component={InvoiceVerificationList}></Route>
        <Route path="/main/statementPaymentProgress" component={StatementPaymentProgress} />
        {/* 首页 */}
        <Route path="/main/home" component={home} />
        {/* 菜单名称/URL 更新工具 */}
        <Route path="/main/menuUpdate" component={MenuUpdate} />
      </div>
    )
  }
}

export default withRouter(AppRoute)



// WEBPACK FOOTER //
// ./src/routes/app-route.js